export const PWA_SHOW_IN_MS = 5 * 24 * 60 * 60 * 1000;

export const HEADER_OFFSET_PX = 220;

export const STORAGE_KEY = "app-color-scheme";

export const ALLOW_PUSH_NOTIF_SHOW_IN_MS = 2 * 24 * 60 * 60 * 1000;

export const LS_LAST = "push:lastPromptAt";

export const SCROLL_CONTAINER_ID = "app-scroll-container";

//Adtrace Events
export const EVT_CTA_SPLASH_CONTINUE = import.meta.env
  .VITE_ADTRACE_EVT_CTA_SPLASH_CONTINUE as string;

export const EVT_LOGIN_PHONE_SUBMIT = import.meta.env
  .VITE_ADTRACE_EVT_LOGIN_PHONE_SUBMIT as string;

export const EVT_LOGIN_GOOGLE_CLICK = import.meta.env
  .VITE_ADTRACE_EVT_LOGIN_GOOGLE_CLICK as string;

export const EVT_OTP_SUBMIT = import.meta.env
  .VITE_ADTRACE_EVT_OTP_SUBMIT as string;

export const EVT_OTP_CONFIRM_CLICK = import.meta.env
  .VITE_ADTRACE_EVT_OTP_CONFIRM_CLICK as string;

export const EVT_OTP_SUCCESS = import.meta.env
  .VITE_ADTRACE_EVT_OTP_SUCCESS as string;

export const EVT_OTP_ERROR = import.meta.env
  .VITE_ADTRACE_EVT_OTP_ERROR as string;

export const EVT_OTP_RESEND = import.meta.env
  .VITE_ADTRACE_EVT_OTP_RESEND as string;

export const EVT_QUESTIONS_REGISTER_SUCCESS = import.meta.env
  .VITE_ADTRACE_EVT_QUESTIONS_REGISTER_SUCCESS as string;

export const EVT_QUESTIONS_REGISTER_ERROR = import.meta.env
  .VITE_ADTRACE_EVT_QUESTIONS_REGISTER_ERROR as string;

export const EVT_CTA_PHYSICAL_REPORT_CONTINUE = import.meta.env
  .VITE_ADTRACE_EVT_CTA_PHYSICAL_REPORT_CONTINUE as string;
